// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"M4-z","displaySixCardTiles":"N4-z"};